import clsx from "clsx";
import type { HTMLInputTypeAttribute } from "react";
import type {
	FieldErrors,
	Path,
	RegisterOptions,
	UseFormRegister,
} from "react-hook-form";

interface Props {
	label?: Path<any>;
	name: string;
	type?: HTMLInputTypeAttribute;
	register: UseFormRegister<any>;
	errors: FieldErrors<any>;
	requiredOptions?: RegisterOptions<any, string> | undefined;
	className?: string;
	labelClassName?: string;
	isOptional?: boolean;
	placeholder?: string;
	disabled?: boolean;
	containerClassName?: string;
}

const FormTextField = ({
	label,
	name,
	type = "text",
	register,
	disabled,
	errors,
	requiredOptions,
	className,
	containerClassName,
	labelClassName,
	isOptional,
	placeholder,
}: Props) => {
	return (
		<div
			className={clsx("flex w-full flex-1 flex-col gap-2", containerClassName)}
		>
			{label && (
				<label
					htmlFor={name}
					className={clsx(
						"flex items-center justify-between font-medium text-gray-700 dark:text-slate-50",
						labelClassName,
					)}
				>
					{label}{" "}
					{isOptional ? (
						<span className="font-normal text-slate-500 dark:text-slate-300">
							Optional
						</span>
					) : (
						<span className="font-normal text-red-500 dark:text-red-300">
							{errors[name]?.message as string}
						</span>
					)}
				</label>
			)}

			<input
				{...register(name, requiredOptions)}
				className={clsx(
					{
						"border-red-400 focus:ring-red-50 dark:border-red-300 dark:focus:ring-red-300/20":
							errors[name],
					},
					className,
				)}
				disabled={disabled}
				placeholder={placeholder}
				type={type}
				id={name}
				aria-invalid={errors[name] ? "true" : "false"}
				autoComplete="on"
			/>
		</div>
	);
};

export default FormTextField;
